var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C8.65685 9 10 7.65685 10 6C10 4.34315 8.65685 3 7 3C5.34315 3 4 4.34315 4 6C4 7.65685 5.34315 9 7 9Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C15.1046 8 16 7.10457 16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6C12 7.10457 12.8954 8 14 8Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16C12.1046 16 13.0312 15.0806 12.6697 14.0368C12.6309 13.9248 12.5888 13.8137 12.5433 13.7039C12.2418 12.9759 11.7998 12.3145 11.2426 11.7574C10.6855 11.2002 10.0241 10.7583 9.29611 10.4567C8.56815 10.1552 7.78794 10 7 10C6.21207 10 5.43186 10.1552 4.7039 10.4567C3.97595 10.7583 3.31452 11.2002 2.75736 11.7574C2.20021 12.3145 1.75826 12.9759 1.45673 13.7039C1.41123 13.8137 1.36907 13.9248 1.33027 14.0368C0.968854 15.0806 1.89544 16 3 16H11Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4292 13H14.4185C13.8751 11.6576 12.9779 10.4963 11.8426 9.63166C12.041 9.50462 12.2506 9.39505 12.4693 9.30448C12.9546 9.10346 13.4747 9 14 9C14.5253 9 15.0454 9.10346 15.5307 9.30448C16.016 9.5055 16.457 9.80014 16.8284 10.1716C17.1999 10.543 17.4945 10.984 17.6955 11.4693C18.0275 12.2708 17.2967 13 16.4292 13Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.f5d33d5b5642905bbd2db61d45bcb24b.svg";
export { ForwardRef as ReactComponent };